<adaa-item-slider class="my-3" [showPerformance]="true" [scrollInput]="316" [arrowsInHeader]="true">
    <h5 title class="py-2 ai-perf__title">
        {{ "dashboard.agentic_ai" | translate }}
        <b>{{ periodLabel() }}</b>
    </h5>

    <!-- The [performance] host stays a static child: Angular resolves projection
         slots at compile time, so a node behind @if falls into the default slot
         and lands inside the scrolling rail instead of the performance panel. -->
    <div performance class="ai-perf__overall d-flex align-items-center justify-content-center">
        @if (performance.value(); as overall) {
            <adaa-ai-performance-card [data]="overall" [name]="'ai_projects.title' | translate" />
        }
    </div>

    @for (item of tracks(); track item.trackId) {
        <adaa-ai-performance-card [data]="item" [name]="item | translateToken: 'trackName'" />
    }
</adaa-item-slider>
